import React from 'react';
import { ChangeEvent, useRef, useState } from 'react';
import { RBHBox, RBHButton, RBHText } from '../../../../../shared/components';
import { Checkbox } from 'antd';
import styles from './styles';
import './styles.css';
import {
	httpCreators,
	useLoadingSelector,
} from '@ppvrbh/merchant-frontend-core';
import { INVITATION_REQUEST_ID_LIST } from '../redux/invitation-constant';
import { useDispatch, useSelector } from 'react-redux';
import {
	GetTncDetailHandlerResp,
	invitationSagas,
} from '../redux/invitation-saga';
import { InvitationService } from '../redux/invitation-service';
import { invitationCreators } from '../redux/invitation-action';
import {
	INVITATION_STATE_KEY,
	InvitationFormData,
	invitationStateSelector,
	InvitationStep,
} from '../redux/invitation-reducer';

export const InvitationTermsSection = () => {
	const dispatch = useDispatch();
	const termsScrollRef = useRef<HTMLDivElement | null>(null);
	const invitationFormData = useSelector(
		invitationStateSelector(INVITATION_STATE_KEY.FORM),
	) as InvitationFormData;
	const invitationTncDetailData = useSelector(
		invitationStateSelector(INVITATION_STATE_KEY.TNC_DETAIL),
	) as GetTncDetailHandlerResp | null;

	const [termsReachedEnd, setTermsReachedEnd] = useState(false);
	const [scrollBottom, setScrollBottom] = useState(false);
	const [agreedTerms, setAgreedTerms] = useState(false);

	const invitationStep = useSelector(
		invitationStateSelector(INVITATION_STATE_KEY.STEP),
	) as InvitationStep;

	const isSubmitting = useLoadingSelector(
		INVITATION_REQUEST_ID_LIST.POST_INVITATION_REGISTRATION,
	);

	const handleTermsScroll = (event: React.UIEvent<HTMLDivElement>) => {
		const scrollElement = event.currentTarget;
		const reachedBottom =
			scrollElement.scrollTop + scrollElement.clientHeight >=
			scrollElement.scrollHeight - 8;

		if (reachedBottom) {
			setTermsReachedEnd(true);
		}
	};

	const handleScroll = (event: ChangeEvent<HTMLDivElement>) => {
		const { scrollTop, scrollHeight, clientHeight } = event.target;
		if (Math.abs(scrollHeight - clientHeight - scrollTop) < 1) {
			setScrollBottom(true);
		}
	};

	const handleInvitationSuccess = () => {
		dispatch(
			invitationCreators.setInvitationState(
				INVITATION_STATE_KEY.STEP,
				'success',
			),
		);
	};

	const handleAcceptTerms = () => {
		dispatch(
			httpCreators.request({
				id: INVITATION_REQUEST_ID_LIST.POST_INVITATION_REGISTRATION,
				sagaHandler: invitationSagas.postInvitationRegistrationHandler,
				callbackParams: {
					onSuccess: handleInvitationSuccess,
				},
				service: InvitationService.postInvitationRegistration,
				serviceParams: {
					contactName: invitationFormData.contactName,
					contactNumber: invitationFormData.contactNumber,
					campaignName: invitationFormData.campaignName,
					availableTime: invitationFormData.availableTime,
					tncVersion: invitationTncDetailData?.version,
					channel: invitationFormData.channel ?? 'email',
					token: invitationFormData.token ?? '',
				},
			}),
		);
	};

	if (invitationStep !== 'terms') {
		return null;
	}

	return (
		<RBHBox
			onScroll={handleScroll}
			className='invitation-form-section'
			style={styles.formSection}
		>
			<RBHBox className='invitation-terms-section' style={styles.termsSection}>
				<RBHText style={styles.sectionTitle}>ข้อกำหนดและเงื่อนไข</RBHText>
				<RBHBox className='invitation-terms-card' style={styles.termsCard}>
					<div
						className='invitation-terms-content'
						ref={termsScrollRef}
						style={styles.termsScroll}
						onScroll={handleTermsScroll}
						dangerouslySetInnerHTML={
							invitationTncDetailData?.th
								? { __html: invitationTncDetailData.th }
								: undefined
						}
					/>

					<label style={styles.checkboxRow}>
						<Checkbox
							checked={agreedTerms}
							disabled={!termsReachedEnd}
							onChange={(event) => setAgreedTerms(event.target.checked)}
						/>
						<span
							style={
								!termsReachedEnd
									? styles.checkboxLabelDisabled
									: styles.checkboxLabel
							}
						>
							ข้าพเจ้าได้อ่านและยอมรับข้อตกลงและเงื่อนไข
						</span>
					</label>
				</RBHBox>
			</RBHBox>

			<RBHBox style={styles.buttonWrap}>
				<RBHButton
					className='invitation-button'
					id='invitation-accept-terms'
					data-testid='invitation-accept-terms'
					disabled={!agreedTerms || !scrollBottom || isSubmitting}
					style={{
						...styles.submitButton,
						...(!agreedTerms || isSubmitting
							? styles.submitButtonDisabled
							: {}),
					}}
					onClick={handleAcceptTerms}
				>
					ยืนยัน
				</RBHButton>
			</RBHBox>
		</RBHBox>
	);
};
